<app-user-info-view
  *ngIf="mode === 'view'"
  [organisationId]="organisationId"
  [data]="data$ | async"
  [committeesList]="committeesList$ | async"
  [allowDeleting]="allowDeleting"
  [allowExcluding]="allowExcluding"
  (startEditing)="onStartEditing()"
  (deleted)="deleted.emit($event)"
  (excluded)="excluded.emit($event)"
  [externalLoading]="loading"
></app-user-info-view>

<app-user-info-edit
  *ngIf="mode !== 'view'"
  [mode]="mode"
  [organisationId]="organisationId"
  [isParentOrganisation]="isParentOrganisation"
  [data]="data$ | async"
  [searchByPhone]="searchByPhone"
  [searchByEmail]="searchByEmail"
  (saved)="onSaveData($event)"
  (canceled)="onCancel()"
></app-user-info-edit>
